import React from 'react';
import { Alert } from 'shared-components';

function GraphQLError({ graphQLErrors }) {
  return <>
    {graphQLErrors.map(({ message, locations, path }, idx) => (
      <Alert key={idx} type="danger">
        {message}
      </Alert>
    ))}
  </>;
}

export default GraphQLError;
